import React from 'react'

const NotFound = () => {
  return (
    <>
      <h1>404</h1>
      <p>您当前访问的路径不存在，请根据导航菜单找到您需要的文档。</p>
    </>
  )
}

export default NotFound
